import React, { useState, useEffect } from 'react';
import '../app/app.component.css';
import royal_backs from './img/royal-backs-logo.png';
import royal_group from './img/royal-group-logo.png';
import meet_greet from './img/meet-greet.jpeg'
import bday from './img/bday.jpeg'
import balloons from './img/balloons.jpeg'

const HomePage: React.FC = () => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [isWordFadeIn, setIsWordFadeIn] = useState(true);
  const words = ['SMILES.', 'LAUGHS.', 'DREAMS.', 'MEMORIES.', 'MAGIC.'];
  const fadeDuration = 1500;

  // Image carousel test
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const slides = [royal_backs, royal_group];

  useEffect(() => {
    const interval = setInterval(() => {
      showSlides(currentSlideIndex + 1);
    }, 12500);

    return () => clearInterval(interval);
  }, [currentSlideIndex]);

  const plusSlides = (n: number) => {
    setCurrentSlideIndex((prevIndex) => (prevIndex + n + slides.length) % slides.length);
  };

  const showSlides = (index: number) => {
    setCurrentSlideIndex(index % slides.length);
  };

  interface CardItemProps {
    imgSrc: string;
    title: string;
    description: string;
    ctaLink: string;
    ctaText: string;
  }

  const CardItem: React.FC<CardItemProps> = ({ imgSrc, title, description, ctaLink, ctaText }) => (
    <div className="card-item">
      <img src={imgSrc} alt={title} />
      <div className="card-content">
        <h2>{title}</h2>
        <p>{description}</p>
        <a href={ctaLink} className="cta-button" target={"_blank"}>{ctaText}</a>
      </div>
    </div>
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setIsWordFadeIn(false);
      setTimeout(() => {
        setCurrentWordIndex((prevIndex) => (prevIndex === words.length - 1 ? 0 : prevIndex + 1));
        setIsWordFadeIn(true);
      }, fadeDuration);
    }, 12500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className='home-container'>
      <div className="image-wrapper">
        {slides.map((slide, index) => (
          <div className={`mySlides ${index === currentSlideIndex ? 'show' : ''}`} key={index}>
            <img src={slide} alt={`Slide ${index}`} />
          </div>
        ))}
        <a className="prev" onClick={() => plusSlides(-1)}>&#10094;</a>
        <a className="next" onClick={() => plusSlides(1)}>&#10095;</a>
      </div>

      <div className="block-2">
        <div className="heading-wrapper">
          <h1 className="home-text">
            We create{' '}
            <span className={`fade-effect ${isWordFadeIn ? 'fade-in' : 'fade-out'}`}>
              {words[currentWordIndex]}
            </span>
          </h1>
        </div>

        <div className="second-container">
          <CardItem
            imgSrc={meet_greet}
            title="Public Meet & Greets"
            description="For our Corporate Clients. Add a character to any special event, such as Employee Picnics, Mall Visits, Luncheons, Milestones, Walks/Runs and more."
            ctaLink="https://docs.google.com/forms/d/e/1FAIpQLSemFwp8FmyIylA0-FggpQf7wHyDN-M_i0j8AJbfCDuNsO3p8g/viewform"
            ctaText="Learn More"
          />
          <CardItem
            imgSrc={bday}
            title="Birthday Party Visits"
            description="Planning a birthday party? We offer Character led activities - 45 and 60 minute package options with Superheroes, Princesses & Galactic Characters."
            ctaLink="/pricing"
            ctaText="Book Now"
          />
          <CardItem
            imgSrc={balloons}
            title="Event & Party Balloons"
            description="Did you know that we offer balloon decor too!?! Our sister company, We Rise Balloons offers themed balloons for your party or event."
            ctaLink="https://docs.google.com/forms/d/e/1FAIpQLSf4HlMpQM_SALGUH4ooySYEnh9wcaStBixureY35Dt09x3PBA/viewform"
            ctaText="Order Now"
          />
        </div>
      </div>
      <div className="block-3">
        <div className="heading-wrapper">
          <h1 className="home-text">
            Follow us on social media for updates and events!
          </h1>
          <div className="video-container">
            <iframe src="https://www.youtube.com/embed/N-4aBga8ft4?si=kf25fEuNM4JK81Qv" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
          </div>
        </div>
      </div>
    </div>
  );

};

export default HomePage;